export default __webpack_public_path__ + "static/media/Front.11fc48e5.png";